// extracted by mini-css-extract-plugin
export default {"info":"info_info__hjsfO","button":"info_button__mMakJ","text":"info_text__M4mO9"};